import React, { useState, useContext, useEffect, useCallback } from 'react'
import { Link, NavLink, useHistory } from 'react-router-dom'
import Popup from '../../../Product/components/organisms/Popup'
import { Copyrightinfo, FooterLogo, Logo } from '../../../utils'
import MetaTag from '../../../utils/CommonFunctionality/SEO/MetaTag'
import GoogleMap from '../../../utils/CommonFunctionality/GoogleMap'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import './Footer.css'
import { use } from 'i18next'
import AuthContext from '../../../Product/context/auth/authContext'
import { handleRedirectInternal, jsonToFormData } from '../../../Product/common/components'
import UserContext from '../../../Product/context/user/userContext'
import AlertContext from '../../../Product/context/alert/alertContext'
import { Facebook, Instagram } from '@material-ui/icons'
import { useLocation } from 'react-router-dom/cjs/react-router-dom'

const Footer = React.memo(() => {
    const [openModal, setModal] = useState(false)
    const isMobile = useMediaQuery('(max-width: 768px)')
    const authContext = useContext(AuthContext)
    const userContext = useContext(UserContext)
    const alertContext = useContext(AlertContext)
    const { isAuthenticated, user } = authContext
    let { editProfile } = userContext
    const { setAlert } = alertContext
    const [email, setEmail] = useState('')

    const history = useHistory()
    const contactEmail = global?.storeDetails?.contact_email
    const contactPhone = global?.storeDetails?.phone
    const facebookLink = global?.storeDetails?.facebook
    const twitterLink = global?.storeDetails?.twitter
    const googleLink = global?.storeDetails?.google
    const instagram = global?.storeDetails?.instagram
    const youtube = global?.storeDetails?.youtube
    const tiktok = global?.storeDetails?.tiktok
    const getStaticPageData = global?.staticDetails || []
    const isBuyBestProject = global.storeConfigration?.bodyClass2?.value === 'buyBestProject'
    const isVarifiedGfTheme = global.storeConfigration?.bodyClass?.value === 'greenField'
    const isBargainsProject = global.storeConfigration?.bodyClass2?.value === 'bargainsClass'
    const changeDialogStatus = useCallback(() => {
        setModal((prev) => !prev)
    }, [])

    const handleSubscribe = useCallback(() => {
        if (!isAuthenticated) {
            handleRedirectInternal(history, 'sign-up')
            return
        }
        if (
            String(email)
                .toLowerCase()
                .match(
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                )
        ) {
            editProfile(
                jsonToFormData({
                    first_name: user.first_name,
                    last_name: user.last_name,
                    email: user.email,
                    phone: user.phone,
                    country: user.country,
                    state: user.state,
                    city: user.city,
                    address1: user.address1,
                    address2: user.address2,
                    zip: user.zip,
                    role: user.role,
                    company_name: user.company_name,
                    auction_io: 1,
                    subscribed: true,
                }),
                'footer',
            )
        } else if (email.length <= 0) {
            setAlert('Please Enter Email ID!', 'error')
        } else {
            setAlert('Invalid Email!', 'error')
        }
    }, [isAuthenticated, email, user, editProfile, setAlert, history])

    useEffect(() => {
        if (user?.email) {
            setEmail(user.email)
        }
    }, [user])

    const greenFieldFoot = [
        {
            MenuHead: 'Discover Us',
            MenuListGroup: [
                {
                    MenuList: 'How It Works',
                    link: '/how_it_works',
                },
                {
                    MenuList: 'FAQ',
                    link: '/faq',
                },
                {
                    MenuList: 'About Us',
                    link: '/aboutus',
                },
            ],
        },
        {
            MenuHead: 'Extra',
            MenuListGroup: [
                {
                    MenuList: 'Rush Perks',
                    link: '/rush_perks',
                },

                {
                    MenuList: 'Rush Bins',
                    link: '/rush_bins',
                },
                {
                    MenuList: 'Locations',
                    link: '/locations',
                },
            ],
        },
        {
            MenuHead: 'Customer Support',
            MenuListGroup: [
                {
                    MenuList: 'Product Conditions',
                    link: '/conditions',
                },
                {
                    MenuList: 'Policies',
                    link: '/privacy_policy',
                },
            ],
        },
        {
            MenuHead: 'Need More Help?',
            MenuListGroup: [
                {
                    MenuList: 'Contact Us',
                    link: '/contact_us',
                },
            ],
        },
        {
            MenuHead: 'Compare',
            MenuListGroup: [
                {
                    MenuList: '',
                    link: '',
                },
            ],
        },
    ]
    const [greenFieldFootState, setGreenFieldFootState] = useState(greenFieldFoot)

    useEffect(() => {
        const compareExists = getStaticPageData.some((dd) => dd.title === 'Compare')
        if (compareExists) {
            // show ALL items exactly as original
            setGreenFieldFootState(greenFieldFoot)
        } else {
            // hide/remove the Compare section
            setGreenFieldFootState((prev) => prev.filter((item) => item.MenuHead !== 'Compare'))
        }
    }, [getStaticPageData])

    const storeId = global?.storeDetails?.id || ''

    const buyFieldFoot = [
        {
            MenuHead: 'Discover Us',
            MenuListGroup: [
                {
                    MenuList: 'How It Works',
                    link: `/how_it_works`,
                },
                {
                    MenuList: 'FAQ',
                    link: `/faq`,
                },
                {
                    MenuList: 'About Us',
                    link: `/aboutus`,
                },
            ],
        },
        {
            MenuHead: 'Extra',
            MenuListGroup: [
                {
                    MenuList: 'Locations',
                    link: '/locations',
                },
            ],
        },
        {
            MenuHead: 'Customer Support',
            MenuListGroup: [
                {
                    MenuList: 'Product Conditions',
                    link: `/product_conditions`,
                },
                {
                    MenuList: 'Policies',
                    link: `/privacy_policy`,
                },
                {
                    MenuList: 'Terms & Conditions',
                    link: `/termsOfService`,
                },
            ],
        },
        {
            MenuHead: 'Need More Help?',
            MenuListGroup: [
                {
                    MenuList: 'Contact Us',
                    link: `/contact_us`,
                },
            ],
        },
    ]
    const bargainFoot = [
        {
            MenuHead: 'Contact Bargains Depot',
            MenuListGroup: [
                {
                    MenuList: contactEmail,
                    link: `mailto:${contactEmail}`,
                },
                {
                    MenuList: contactPhone,
                    link: `tel:${contactPhone}`,
                },
            ],
        },
        {
            MenuHead: 'Resources',
            MenuListGroup: [
                {
                    MenuList: 'About Us',
                    link: `/${storeId}/aboutus`,
                },

                {
                    MenuList: 'Contact Us',
                    link: `/${storeId}/contact_us`,
                },
                {
                    MenuList: 'FAQ',
                    link: `/${storeId}/faq`,
                },
                {
                    MenuList: 'Privacy Policy',
                    link: `/${storeId}/privacy_policy`,
                },
                {
                    MenuList: 'Terms & Conditions',
                    link: `/${storeId}/termsOfService`,
                },
            ],
        },
    ]
    const footerContent = !isBargainsProject
        ? isBuyBestProject
            ? buyFieldFoot
            : greenFieldFootState
        : bargainFoot
    return (
        <footer className="footer-main-standard noPrint">
            {isVarifiedGfTheme ? (
                <div className="customContainer">
                    <div className="ftrWrprVw greenFieldFooter">
                        <div className="lgAdCntnr">
                            <div className="footerSubcription">
                                {user?.subscribed ? (
                                    <Logo className="headerLogo" />
                                ) : (
                                    <>
                                        <div className="headerSearchField">
                                            <input
                                                type="text"
                                                name="email"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                className="nav-standard-top-area-search-input open-sans"
                                                placeholder="Email Address"
                                            />
                                            <button
                                                className="filterUserSearch lin lin-magnifier nav-standard-top-area-search-sumbit"
                                                onClick={handleSubscribe}
                                            >
                                                Subscribe
                                            </button>
                                        </div>
                                    </>
                                )}
                            </div>
                            <div className="adrsFlds">
                                <div className="label">Follow Us</div>
                                <ul className="footer-main-standard-social-list text-start">
                                    {facebookLink && (
                                        <li className="facebook">
                                            <a
                                                href={facebookLink}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                title="Facebook"
                                            >
                                                {isBuyBestProject ? (
                                                    <Facebook />
                                                ) : (
                                                    <img
                                                        src="/lots-images/greenField/Vector/NewFacebook.svg"
                                                        alt="Facebook"
                                                        height={35}
                                                        width={35}
                                                        loading="lazy"
                                                    />
                                                )}
                                            </a>
                                        </li>
                                    )}
                                    {instagram && (
                                        <li className="instagram">
                                            <a
                                                href={instagram}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                title="Instagram"
                                            >
                                                {isBuyBestProject ? (
                                                    <Instagram />
                                                ) : (
                                                    <img
                                                        src="/lots-images/greenField/Vector/NewInstagram.svg"
                                                        alt="Instagram"
                                                        height={35}
                                                        width={35}
                                                        loading="lazy"
                                                    />
                                                )}
                                            </a>
                                        </li>
                                    )}
                                    {tiktok && (
                                        <li className="linkedin">
                                            <a
                                                href={tiktok}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                title="Linkedin"
                                            >
                                                <img
                                                    src="/lots-images/greenField/Vector/NewTiktok.svg"
                                                    alt="tiktok"
                                                    height={35}
                                                    width={35}
                                                    loading="lazy"
                                                />
                                            </a>
                                        </li>
                                    )}
                                </ul>
                            </div>
                        </div>
                        <div className="twoDivCls">
                            <>
                                {footerContent.map((list, index) => (
                                    <div className="ftrLnkWrpr" key={index}>
                                        <div className="lnkGrdTb">
                                            <h4>{list.MenuHead}</h4>
                                            <ul className="footerLinks">
                                                {list?.MenuListGroup?.map((innerList, subIndex) => (
                                                    <>
                                                        {innerList.MenuList ? (
                                                            <li className="footHiw" key={subIndex}>
                                                                {innerList.MenuList ==
                                                                'Policies' ? (
                                                                    <NavLink
                                                                        to={innerList.link}
                                                                        activeClassName="active"
                                                                    >
                                                                        {innerList.MenuList}
                                                                    </NavLink>
                                                                ) : (
                                                                    <a
                                                                        href={innerList.link}
                                                                        rel="noopener noreferrer"
                                                                    >
                                                                        {innerList.MenuList}
                                                                    </a>
                                                                )}
                                                            </li>
                                                        ) : null}
                                                    </>
                                                ))}
                                                {getStaticPageData
                                                    .filter(
                                                        (page) =>
                                                            page.title === list.MenuHead &&
                                                            page.type === 2,
                                                    )
                                                    .map((page, k) => (
                                                        <li key={k} className="footHiw">
                                                            <NavLink
                                                                to={page.pathname}
                                                                activeClassName="active"
                                                            >
                                                                {page.description_name}
                                                            </NavLink>
                                                        </li>
                                                    ))}
                                            </ul>
                                        </div>
                                    </div>
                                ))}
                                {!isBuyBestProject && !isBargainsProject ? (
                                    <div
                                        className="ftrLnkWrpr"
                                        key={greenFieldFootState.length + 1}
                                    >
                                        <a
                                            href="https://www.bbb.org/us/oh/columbus/profile/discount-stores/retail-rush-0302-70165078/#sealclick"
                                            target="_blank"
                                            rel="nofollow noopener noreferrer"
                                        >
                                            <img
                                                src="/lots-images/greenField/bbb_icon.png"
                                                style={{ border: 0 }}
                                                alt="Retail Rush BBB Business Review"
                                                loading="lazy"
                                            />
                                        </a>
                                    </div>
                                ) : (
                                    ''
                                )}
                            </>
                        </div>
                    </div>
                    <div className="btmLineListGrp">
                        <div className="btnLtline">
                            <Copyrightinfo />
                            <div className="staPglist">
                                {/* <a href="#">Manage Cookies</a> */}
                                <a href={`/${storeId}/privacy_policy`}>Privacy Policy</a>
                                {/* <a href="#">User Agreement</a> */}
                            </div>
                        </div>
                        <div className="btnRtLine">
                            <span className="material-icons-outlined">translate</span>
                            <select aria-label="Select language" name="language">
                                <option>English</option>
                            </select>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="container">
                    <div className="ftrWrprVw d-flex align-items-start justify-content-between">
                        <div className="lgAdCntnr">
                            <div className="ftrLgCntnr">
                                <FooterLogo className="footerLogo" />
                            </div>
                            {!isMobile && (
                                <div className="adrsFlds d-md-block">
                                    <Copyrightinfo />
                                    <ul className="footerLinks social-links">
                                        {facebookLink && (
                                            <li className="facebook">
                                                <a
                                                    href={facebookLink}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    title="Facebook"
                                                >
                                                    <img
                                                        src="/lots-images/facebook.png"
                                                        alt=""
                                                        loading="lazy"
                                                    />
                                                </a>
                                            </li>
                                        )}
                                        {tiktok && (
                                            <li className="pinterest">
                                                <a
                                                    href=""
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    title="tiktok"
                                                >
                                                    <img
                                                        src="/lots-images/tiktok.png"
                                                        alt=""
                                                        loading="lazy"
                                                    />
                                                </a>
                                            </li>
                                        )}
                                        {youtube && (
                                            <li className="pinterest">
                                                <a
                                                    href={youtube}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    title="Youtube"
                                                >
                                                    <img
                                                        src="/lots-images/youtube.png"
                                                        alt=""
                                                        loading="lazy"
                                                    />
                                                </a>
                                            </li>
                                        )}
                                        {instagram && (
                                            <li className="instagram">
                                                <a
                                                    href={instagram}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    title="Instagram"
                                                >
                                                    <img
                                                        src="/lots-images/instagram.png"
                                                        alt=""
                                                        loading="lazy"
                                                    />
                                                </a>
                                            </li>
                                        )}
                                        {googleLink && (
                                            <li className="instagram">
                                                <a
                                                    href={googleLink}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    title="Linkedin"
                                                >
                                                    <img
                                                        src="/lots-images/linkedin.png"
                                                        alt=""
                                                        loading="lazy"
                                                    />
                                                </a>
                                            </li>
                                        )}
                                        {twitterLink && (
                                            <li className="pinterest">
                                                <a
                                                    href={twitterLink}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    title="Twitter"
                                                >
                                                    <img
                                                        src="/lots-images/x.png"
                                                        alt=""
                                                        loading="lazy"
                                                    />
                                                </a>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            )}
                        </div>
                        <div className="twoDivCls">
                            <div className="ftrLnkWrpr d-flex align-items-start">
                                <div className="lnkGrdTb">
                                    <h4>Buy</h4>
                                    <ul className="footerLinks">
                                        <li className="footHiw">
                                            <NavLink activeClassName="active" to="/how_it_works">
                                                How it works
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink activeClassName="active" to="/location_hours">
                                                Location & Hours
                                            </NavLink>
                                        </li>
                                        {global.storeDetails?.shipping_policy ? (
                                            <li>
                                                <NavLink
                                                    activeClassName="active"
                                                    to="/shipping_policy"
                                                >
                                                    Shipping Policy
                                                </NavLink>
                                            </li>
                                        ) : (
                                            ''
                                        )}
                                        <li>
                                            <NavLink activeClassName="active" to="/faq">
                                                FAQs
                                            </NavLink>
                                        </li>
                                        <li>
                                            <a href="https://lotsofauctions.com/category/blog/">
                                                Blog
                                            </a>
                                        </li>
                                    </ul>
                                </div>

                                <div className="lnkGrdTb">
                                    <h4>About</h4>
                                    <ul className="footerLinks">
                                        <li>
                                            <NavLink activeClassName="active" to="/aboutus">
                                                Our Story
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink activeClassName="active" to="/termsOfService">
                                                User Agreement
                                            </NavLink>
                                        </li>
                                        {global.storeDetails?.privacy_policy ? (
                                            <li>
                                                <NavLink
                                                    activeClassName="active"
                                                    to="/privacy_policy"
                                                >
                                                    Privacy Policy
                                                </NavLink>
                                            </li>
                                        ) : (
                                            ''
                                        )}
                                        {global.storeDetails?.jobs ? (
                                            <li className="footHiw">
                                                <NavLink activeClassName="active" to="/jobs">
                                                    Job Opportunities
                                                </NavLink>
                                            </li>
                                        ) : (
                                            ''
                                        )}
                                    </ul>
                                </div>

                                <div className="lnkGrdTb">
                                    <h4>Help & Contact</h4>
                                    <ul className="footerLinks">
                                        <li className="footHiw">
                                            <NavLink activeClassName="active" to="/contact_us">
                                                Contact Us
                                            </NavLink>
                                        </li>
                                        {contactEmail && (
                                            <li>
                                                <a
                                                    href={`mailto:${contactEmail}`}
                                                    className="cvc-link"
                                                >
                                                    {contactEmail}
                                                </a>
                                            </li>
                                        )}
                                        {global.storeConfigration?.hide_phone?.value != 1 &&
                                            contactPhone && (
                                                <li>
                                                    <a
                                                        href={`tel:${contactPhone}`}
                                                        className="cvc-link"
                                                    >
                                                        {contactPhone}
                                                    </a>
                                                </li>
                                            )}
                                    </ul>
                                </div>
                            </div>
                            {global.storeConfigration?.footer_map?.value ? (
                                <div className="myMap">
                                    <GoogleMap />
                                </div>
                            ) : null}
                        </div>
                    </div>
                    {isMobile && (
                        <div className="adrsFlds d-md-block">
                            <Copyrightinfo />
                            <ul className="footerLinks social-links">
                                {facebookLink && (
                                    <li className="facebook">
                                        <a
                                            href={facebookLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title="Facebook"
                                        >
                                            <img
                                                src="/lots-images/facebook.png"
                                                alt=""
                                                loading="lazy"
                                            />
                                        </a>
                                    </li>
                                )}
                                {tiktok && (
                                    <li className="pinterest">
                                        <a
                                            href=""
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title="tiktok"
                                        >
                                            <img
                                                src="/lots-images/tiktok.png"
                                                alt=""
                                                loading="lazy"
                                            />
                                        </a>
                                    </li>
                                )}
                                {youtube && (
                                    <li className="pinterest">
                                        <a
                                            href={youtube}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title="Youtube"
                                        >
                                            <img
                                                src="/lots-images/youtube.png"
                                                alt=""
                                                loading="lazy"
                                            />
                                        </a>
                                    </li>
                                )}
                                {instagram && (
                                    <li className="instagram">
                                        <a
                                            href={instagram}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title="Instagram"
                                        >
                                            <img
                                                src="/lots-images/instagram.png"
                                                alt=""
                                                loading="lazy"
                                            />
                                        </a>
                                    </li>
                                )}
                                {googleLink && (
                                    <li className="instagram">
                                        <a
                                            href={googleLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title="Linkedin"
                                        >
                                            <img
                                                src="/lots-images/linkedin.png"
                                                alt=""
                                                loading="lazy"
                                            />
                                        </a>
                                    </li>
                                )}
                                {twitterLink && (
                                    <li className="pinterest">
                                        <a
                                            href={twitterLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title="Twitter"
                                        >
                                            <img src="/lots-images/x.png" alt="" loading="lazy" />
                                        </a>
                                    </li>
                                )}
                            </ul>
                        </div>
                    )}
                </div>
            )}
            {global.storeConfigration?.meta_tag_pixel_pinacle?.value ? <MetaTag /> : ''}
            <Popup
                open={openModal}
                size="md"
                handleClose={changeDialogStatus}
                modaltitle="Schedule Pickup"
            >
                <div className="schedulePickup">
                    <iframe
                        height={600}
                        src={global.storeConfigration?.external_schedule_pickup_link?.value}
                        loading="lazy"
                    ></iframe>
                </div>
            </Popup>
        </footer>
    )
})

export default Footer
Footer.displayName = 'Footer'
